module.exports = __webpack_public_path__ + "img/two-round.2750b214.svg";